import { LOG_LEVEL } from '../enums/log-level.enum';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

export class PaceError extends Error {}

export function logLevelToSeverityLevel(level: LOG_LEVEL | undefined | null): SeverityLevel | undefined {
    switch (level) {
        case LOG_LEVEL.INFO:
            return SeverityLevel.Information;
        case LOG_LEVEL.DEBUG:
            return SeverityLevel.Verbose;
        case LOG_LEVEL.WARN:
            return SeverityLevel.Warning;
        case LOG_LEVEL.ERROR:
            return SeverityLevel.Error;
        case LOG_LEVEL.NONE:
        case null:
        case undefined:
            return undefined;
        default:
            return SeverityLevel.Information;
    }
}
